import { Injectable } from '@angular/core';
import { ScenarioMock } from '../DataStore/Mock/scenario-mock';
import { ScenarioModel } from '../Models/scenario-model';
import { FeatureModel } from '../Models/feature-model';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScenarioServiceService {
  constructor(private rest: RestService) { }

  public findByObjectId(id: string): ScenarioModel {
    return ScenarioMock.findByObjectId(id);
  }

  public findById(id: number): ScenarioModel {
    return ScenarioMock.findById(id);
  }

  public getItems(): Observable<ScenarioModel[]> {
    let projectId = localStorage.getItem("projectId");
    return this.rest.get('projectScenarios', projectId);
  }

  public getScenariosByFeature(featureModel: FeatureModel): ScenarioModel[] {
    let scenarios = [];
    for (let i = 0; i < featureModel.scenario.length; i++) {
      let s = this.findByObjectId(featureModel.scenario[i]);
      scenarios.push(s);
    }
    return scenarios;
  }

  public addStepToScenario(scenario: ScenarioModel, id: string) {
    this.findByObjectId(scenario.id).scenariosteps.push(id);
  }

  public addNew(name: string, mydata: any) {
    let model = new ScenarioModel();
    model.name = name;
    let projectId = localStorage.getItem("projectId");
    var data: any = {
      project: { _id: projectId },
      scenario: model
    };
    if (mydata && mydata.selectedData) {
      data.projectScenario = {
        issue_id: mydata.selectedData.issue_id,
        issue_key: mydata.selectedData.issue_key,
        issue_summary: mydata.selectedData.issue_summary,
        project_management_type: mydata.selectedData.project_management_type,
        issue_type: mydata.selectedData.issue_type,
        project_management_project_id: mydata.selectedData.project_management_project_id,
        projectName: mydata.selectedData.projectName,
        assignee: mydata.selectedData.assignee,
        parent_id: mydata.selectedData.parent_id,
        parent_type: mydata.selectedData.parent_type,
      };
    }

    return this.rest.put('addscenario', data);
  }

  public edit(model, mydata?: any) {
    let projectId = localStorage.getItem("projectId");
    if (model.models)
      model.models = model.models.map(m => { return m = m.$oid })
    model.created_time = model.created_time.$numberLong;
    model.updated_time = model.updated_time.$numberLong;
    var data: any = {
      project: { _id: projectId },
      scenario: model
    };
    
    // Handle projectScenarioMappingModel for edit scenario
    if (mydata && mydata.projectScenarioMappingModel) {
      console.log('Adding projectScenarioMappingModel to data:', mydata.projectScenarioMappingModel);
      data.projectScenario = mydata.projectScenarioMappingModel;
      data.changed = true;
    }
    // Fallback to old format for backward compatibility
    else if (data && data.selectedData) {
      data.projectScenario = {
        issue_id: data.selectedData.issue_id,
        issue_key: data.selectedData.issue_key,
        issue_summary: data.selectedData.issue_summary,
        project_management_type: data.selectedData.project_management_type,
        issue_type: data.selectedData.issue_type,
        project_management_project_id: data.selectedData.project_management_project_id,
        projectName: data.selectedData.projectName,
        assignee: data.selectedData.assignee,
        parent_id: data.selectedData.parent_id,
        parent_type: data.selectedData.parent_type,
      };
      data.changed = data.selectedData.changed;
    }
    return this.rest.post('updatescenario', data);
  }

  public deleteModel(model) {
    let projectId = localStorage.getItem("projectId");
    if (model.models)
      model.models = model.models.map(m => { return m = m.$oid })
    model.created_time = model.created_time.$numberLong;
    model.updated_time = model.updated_time.$numberLong;
    var data = {
      project: { _id: projectId },
      scenario: model
    };
    return this.rest.post("deletescenario", data);
  }

  public saveAsModel(model) {
    console.log(model);
    let projectId = localStorage.getItem("projectId");
    model.created_time = model.created_time.$numberLong;
    model.updated_time = model.updated_time.$numberLong;
    console.log(model);
    if (model.models) {
      const modelIds = model.models.map(model => model.$oid);
      model['models'] = modelIds;
    }
    console.log(model);
    let data = {
      project: { _id: projectId },
      scenario: model
    };
    console.log(model);
    return this.rest.put('copyscenario', data);
  }

  getJiraIssueList(pageSize: number = 10, nextPageToken: string = '') {
    let projectId = localStorage.getItem("projectId");
    let payload = {
      "projectId": projectId,
      "maxResult": pageSize.toString(),
      "project_management_type": "jira",
      "nextPageToken": nextPageToken
    }
    return this.rest.post('getJiraIssueList', payload, null)
  }
}
